import React, { FC } from 'react';
import { useProfile } from '@hooks/TRPC_Hooks/useProfile';
import { useGetPublicProfile } from '@hooks/TRPC_Hooks/useGetPublicProfile';
import { AvatarBlockLoader } from './AvatarBlockLoader';
import { AvatarBlockLoaded } from './AvatarBlockLoaded';
interface AvatarBlockProps {}
export const AvatarBlock: FC<AvatarBlockProps> = ({}) => {
  const {
    data: profile,
    isLoading: profileLoading
  } = useProfile();
  const {
    data: publicProfile,
    isLoading: publicProfileLoading
  } = useGetPublicProfile({
    shortId: profile?.shortid ?? ''
  }, {
    enabled: !!profile
  });
  const isLoading = profileLoading || publicProfileLoading;
  if (isLoading) return <AvatarBlockLoader />;
  if (!publicProfile) return null;
  return <AvatarBlockLoaded {...publicProfile} data-sentry-element="AvatarBlockLoaded" data-sentry-component="AvatarBlock" data-sentry-source-file="AvatarBlock.tsx" />;
};